/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_CancelInputs */

const en_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fr_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const it_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const nl_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const pl_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const fi_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const da_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const sv_story_bank_cancel = /** @type {(inputs: Story_Bank_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Story_Bank_CancelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_cancel = /** @type {((inputs?: Story_Bank_CancelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_CancelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_cancel(inputs)
	if (locale === "fr") return fr_story_bank_cancel(inputs)
	if (locale === "es") return es_story_bank_cancel(inputs)
	if (locale === "it") return it_story_bank_cancel(inputs)
	if (locale === "nl") return nl_story_bank_cancel(inputs)
	if (locale === "pl") return pl_story_bank_cancel(inputs)
	if (locale === "fi") return fi_story_bank_cancel(inputs)
	if (locale === "da") return da_story_bank_cancel(inputs)
	if (locale === "sv") return sv_story_bank_cancel(inputs)
	return en_story_bank_cancel(inputs)
});